import React from "react";
import { WORKFLOW_STEPS } from "../data/content";
import "../styles/howItWorks.css";

function HowItWorks() {
  return (
    <section className="how" id="how-it-works">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">
            <span className="eyebrow-dot" aria-hidden="true" />
            How it works
          </span>
          <h2 className="section-title">
            From launching the app to a completed HR request
          </h2>
          <p className="section-subtitle">
            The MPeoples HRMS app provides a structured workflow that lets
            employees securely log in, record attendance, and manage HR
            activities end to end.
          </p>
        </div>

        <div className="how-steps">
          {WORKFLOW_STEPS.map((step, index) => (
            <div className="how-step" key={step.title}>
              <div className="how-step-marker">
                <span className="mono-tag">{String(index + 1).padStart(2, "0")}</span>
                {index !== WORKFLOW_STEPS.length - 1 && <span className="how-step-line" />}
              </div>
              <div className="how-step-body">
                <h3 className="how-step-title">{step.title}</h3>
                <p className="how-step-detail">{step.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
